import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/pat_verfuegung.jpg"

const Patientenvefuegung = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung -  Medizinisches Patientenvefügungs-Beratungsgespräch </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Im Falle einer plötzlichen schweren Erkrankung, in deren Verlauf es eventuell vorkommen kann, dass Sie Ihren Willen nicht mehr äußern können, ist es <b> wichtig, Ihren Willen bereits vorher schriftlich festzulegen. </b>
                        <br /><br />
                        Mit der <b>Patientenverfügung</b> steht uns ein wirklich sinnvolles Instrument zur Verfügung, um unsere Wünsche und Vorstellungen für den "Fall der Fälle" unmissverständlich zu dokumentieren.
                        <br /><br />
                        In einer solchen Patientenverfügung können Sie festhalten, welche medizinischen Maßnahmen nach Ihren persönlichen Vorstellungen vorzunehmen oder zu unterlassen sind, wie z.B. das Nichtergreifen von speziellen Maßnahmen, die Fortsetzung von lebensverlängernden Interventionen, künstliche Ernährung, Beatmung, Schmerztherapie, etc.
                        <br /><br />
                        Mit diesem <b>ausführlichen medizinischen Beratungsgespräch</b> werden Sie beim Ausfertigen Ihrer Patientenverfügung - ob beachtlich oder verbindlich - von uns gerne unterstützt.
                        <br /><br />
                        Im Anschluss daran, muss diese Patientenverfügung unbedingt noch von einem Notar bzw. Rechtsanwalt bestätigt werden.
                        <br /><br />
                        Bitte das <a href="!#"> Musterformular </a> downloaden 
                        <br /><br />
                        Es handelt sich hierbei um eine Leistung, welche nicht von den Krankenkassen bezahlt wird, sondern privat verrechnet werden muss (160.- Euro).
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Patientenvefuegung;